<template>
  <div class="row">
    <div class="col-lg-6">
      <Diarie></Diarie>
    </div>
  </div>
</template>
<script>
import Diarie from "./Diarie.vue";

export default {
  components: {
    Diarie
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    //
  }),

  computed: {
    //
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    //
  }
};
</script>

<style scoped></style>
